import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`NUTRITION`}</h2>
    <p>{`To get to Zero Hunger, food is not enough. Providing food assistance in an emergency can save lives, but the right nutrition at the right time can also help change lives and break the cycle of poverty.`}</p>
    <p>{`Poor nutrition remains a colossal problem, with one in three people on the planet affected by some form of malnutrition. That is why WFP prioritises nutrition as a core element of its work. Where malnutrition threatens the world’s most vulnerable people, WFP is at the forefront to prevent it – and treat it when it does occur.`}</p>
    <p><strong parentName="p">{`Bangladesh`}</strong>{` houses the world’s largest refugee camp where WFP provides nearly 900,000 Rohingya refugees with food assistance thanks to donors like the EU. As part of its EU-funded work in 2019, WFP distributed specialised nutrition products to pregnant and nursing mothers and children under five, who are susceptible to malnutrition. `}</p>
    <p>{`In `}<strong parentName="p">{`Colombia`}</strong>{`, the risk of malnutrition and micronutrient deficiency is particularly high among more than 1.8 million Venezuelan refugees living in the country. In 2019, with the help from donors such as the EU, WFP provided more than 250,000 people from the refugee and Colombian host communities with food assistance and nutrition education to change their eating habits. `}</p>
    <p>{`Thanks to donors like the EU, WFP supported health centres across `}<strong parentName="p">{`Ethiopia`}</strong>{` to help vulnerable people improve their nutrition. These clinics assessed the health of mothers and their children, providing specialised nutritious food to help those that are underweight and malnourished get healthy and gain strength.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      